import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Inbox.css';
import cx from 'classnames';
import { graphql, gql, compose } from "react-apollo";

// Component
import Link from '../Link';

// Locale
import messages from '../../locale/messages';
import history from '../../core/history';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
class SideMenu extends React.Component {

    static propTypes = {
            data: PropTypes.shape({
                loading: PropTypes.bool,
                ManageListings: PropTypes.arrayOf(PropTypes.shape({
                    id: PropTypes.number.isRequired,
                    title: PropTypes.string.isRequired
                }))
            })
        };

    constructor(props) {
        super(props);
        this.state = {
            location: ''
        }
    }

    componentDidMount() {
        if (history.location) {
            this.setState({
                location: history.location.pathname
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (history.location) {
            this.setState({
                location: history.location.pathname
            });
        }
    }

    render() {
        const { location } = this.state;
        const { data: { ManageListingTransaction } } = this.props;
        return (
            <div>
                <ul className={cx('sideMenuBorder', 'listLayoutArbic')}>
                    <li className={cx('sideMenuBorderPadding', { ['menuActive']: location === "/inbox" })}  onClick={() => this.setState({ location: history.location.pathname })}>
                        <Link to={"/inbox"} className={cx('sideNavitem', 'sideNav')}>
                            <FormattedMessage {...messages.inbox} />
                        </Link>
                    </li>
                    {
                    ManageListingTransaction && ManageListingTransaction.length > 0  && (
                    <li className={cx('sideMenuBorderPadding', { ['menuActive']:  location === "/inbox/inbox-message"})} onClick={() => this.setState({ location: history.location.pathname })}>
                        <Link to={"/inbox/inbox-message"} className={cx('sideNavitem', 'sideNav')}>
                            <FormattedMessage {...messages.inboxMessageConfigurationsLabel} />
                        </Link>
                    </li>)}
                </ul>
            </div>
        );
    }
}

const mapState = (state) => ({});

const mapDispatch = {};

export default compose(
    connect(mapState, mapDispatch),
    injectIntl,
    withStyles(s),
    graphql(gql`
        {
            ManageListingTransaction {
                id
                title
                isReady
            }
        }
    `,
        {
            options: {
                ssr: false
            }
        }),
)(SideMenu);